/**
 * Language utility functions
 */
import { LangKey } from '../types'

/**
 * Convert langKey to Sanity field key
 * 'zh-hant' -> 'zhHant'
 * 'en' -> 'en'
 */
export function getLangFieldKey(langKey: LangKey): 'zhHant' | 'en' {
  return langKey === 'zh-hant' ? 'zhHant' : 'en'
}

/**
 * Get page title for IR category
 */
export function getCategoryTitle(langKey: LangKey, category: string): string {
  const titles: Record<string, Record<string, string>> = {
    'Announcements and Circulars': {
      'zh-hant': '公告與通函',
      en: 'Announcements and Circulars',
    },
    'Press Releases': {
      'zh-hant': '新聞發布',
      en: 'Press Releases',
    },
    'Corporate Governance': {
      'zh-hant': '企業管治',
      en: 'Corporate Governance',
    },
    'Financial Reports': {
      'zh-hant': '財務報告',
      en: 'Financial Reports',
    },
  }
  return titles[category]?.[langKey] ?? category
}

/**
 * Get the alternate language URL for a given path
 */
export function getAlternateLangPath(currentPath: string, currentLang: LangKey): string {
  if (currentLang === 'en') {
    // Remove /en/ prefix
    return currentPath.replace(/^\/en/, '') || '/'
  } else {
    // Add /en/ prefix
    return `/en${currentPath}`
  }
}
